import { TechnicianTimesheet } from "../../Api/technicianTimesheet";
import {
  FETCH_MONTHDATA_SUCCESS,
  FETCH_MONTHDATA_REQUEST,
  FETCH_MONTHDATA_FAILURE
} from "../../Constants";
function requestMonthTimesheet() {
  return {
    type: FETCH_MONTHDATA_REQUEST,
    isFetching: true
  };
}

function monthTimesheetDataSuccess(data) {
  return {
    type: FETCH_MONTHDATA_SUCCESS,
    isFetching: false,
    data
  };
}

function monthTimesheetError(errorMessage) {
  return {
    type: FETCH_MONTHDATA_FAILURE,
    isFetching: false,
    errorMessage
  };
}

export const getMonthTimesheetData = payload => (dispatch, getState) => {
  dispatch(requestMonthTimesheet());
  TechnicianTimesheet.fetchMonthTimesheetData(payload)
    .then(res => {
      dispatch(monthTimesheetDataSuccess(res));
    })
    .catch(err => dispatch(monthTimesheetError(err)));
};
